import { ComponentType } from 'react'
import { QueueJobKind } from '../../hooks/queue/queueTypes'
import { QueueToastContentProps } from './queueToastTypes'
import DocumentToastContent from './DocumentToastContent'
import EmailFilingToastContent from './EmailFilingToastContent'
import TimeSuggestionToastContent from './TimeSuggestionToastContent'

/**
 * Which toast renders which kind of job. Adding a kind means adding an entry here; the dispatcher no longer has to be
 * handed a render function, which is what used to force the job data through an untyped render callback.
 */
export const queueToastContent: Record<QueueJobKind, ComponentType<QueueToastContentProps>> = {
    [QueueJobKind.Document]: DocumentToastContent,
    [QueueJobKind.EmailFiling]: EmailFilingToastContent,
    [QueueJobKind.TimeSuggestion]: TimeSuggestionToastContent,
}
